export const APPROVAL_STATE = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    DECLINED: 'DECLINED',
    WITHDRAWN: 'WITHDRAWN',
    EXPIRED: 'EXPIRED',
};
